import React, { useEffect, useState } from "react";
import axios from "axios";

import { GET_PRODUCTS, APP_BASE_URL } from "../../AppConstant";
import LoadingGif from "../../../assets/images/Spin_loader.gif"
import { red } from "@mui/material/colors";

function ListProductPage({setParentLoading}) {
    const [products, setProducts] = useState([]);

    const fetchProducts = async () => {
         try {
                    setParentLoading(true);
        
                    const res = await axios.get(GET_PRODUCTS);
        
                    const products = res.data;
        
                    const imagePromises = products.map((item) => {
                        return new Promise((resolve) => {
                            const img = new Image();
        
                            img.onload = resolve;
                            img.onerror = resolve;
        
                            img.src = `${APP_BASE_URL}/products/getproductimage/${item.id}`;
                        });
                    });
        
                    await Promise.all(imagePromises);
        
                    setProducts(products);
        
                     setTimeout(() => {
                    setParentLoading(false);
                }, 500);
        
                } catch (err) {
                     setTimeout(() => {
                    setParentLoading(false);
                }, 500);
                    console.error(err);
                }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <div>

            <table className="mt-3 fw-bold">
                <thead className="bg-primary" style={{color:"var(--bs-white)"}} >
                    <tr>
                        <th>S.No</th>
                        <th>Product Name</th>
                        <th>Product Count</th>
                        <th>Image</th>
                    </tr>
                </thead>

                <tbody className="text-secondary" style={{fontSize:"small", width:"100%"}} >
                    {products.length > 0 ? (
                        products.map((item, index) => (
                            <tr key={item.id}>

                                <td style={{width:"10%"}}>{index + 1}</td>
                                <td style={{width:"35%"}}>{item.name}</td>
                                <td style={{width:"35%"}}>{item.count}</td>

                                <td style={{width:"20%", padding:"0"}}>
                                    <img
                                        src={`${APP_BASE_URL}/products/getproductimage/${item.id}`}
                                        alt="Product"
                                        style={{
                                            width: "100%",
                                            height: "150px",
                                        }}
                                        
                                    />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                                No products available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>


        </div>
    );
}

export default ListProductPage;